/**
 * @fileoverview History searcher for tracking search history and viewed items.
 * @module searchers/HistorySearcher
 */

import { IntSearcher } from './IntSearcher.js';
import { MAPAPP_DEFAULTS, SEARCH_TYPES } from '../constants.js';
import { createIntSearcherConfig } from './IntSearcherConfigs.js';


/**
 * Manages search history and recently viewed items.
 * Stores search queries with result counts and timestamps,
 * allowing users to re-run previous searches.
 * @class
 * @extends IntSearcher
 */
export class HistorySearcher extends IntSearcher {
    /**
     * Creates a new HistorySearcher instance.
     * @param {Object} mapApp - The MapApp instance
     * @param {Object} [options={}] - Configuration options
     */
    constructor(mapApp, options = {}) {
        const config = createIntSearcherConfig(SEARCH_TYPES.HISTORY, {
            ...options
        });

        super(mapApp, config);
    }



    // Click handling is inherited from Searcher.handleItemClick()
    // which handles delete button, execute button, and doubleclick on searches


    /**
     * Adds a history item directly to the history list.
     * @param {Object} item - The item to add to history
     * @returns {Object|null} The added item or null if failed
     */
    addHistoryItemDirect(item) {
        // caller will perform needed refresh
        const debugMessage = 'adding history';
        const flagResetTimestamp = true;
        const retv = this.addItemRefDirect(item, debugMessage, flagResetTimestamp);
        // notify changes
        this.mapApp.displayNeedsRefresh_AfterResultItemAddHistory(item);
        return retv;
    }
}
